<template>
  <v-select
    v-model="localValue"
    :items="operators"
    item-text="label"
    item-value="value"
    label="Operator"
    dense
    outlined
    hide-details
  ></v-select>
</template>

<script>
export default {
  name: "FilterOperatorSelect",
  props: {
    value: {
      type: String,
      required: true,
    },
    operators: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    localValue(newVal) {
      this.$emit("input", newVal);
      this.$emit("change", newVal);
    },
  },
};
</script>